import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

  import LeuckentextQuestionItem from '@/components/course/leuckentext/LeuckentextQuestionItem.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'

  import useIcons from '@/composables/useIcons'
  import useI18n from '@/composables/useI18n'

  import type { PropType } from 'vue'
  import type { LeuckentextQuestionItem as ILeuckentextQuestionItem } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LeuckentextResultsMode',
  props: {
    leuckentextItems: {
      type: Array as PropType<ILeuckentextQuestionItem[]>,
      required: true,
    },
    correctItemIds: {
      type: Array as PropType<string[]>,
      required: true,
    },
    attempt: {
      type: Number,
      required: true,
    },
    successMessage: String,
    failureMessage: String,
  },
  emits: ['try-again'],
  setup(__props) {

const props = __props;

  

  

  const { translateString } = useI18n()
  const { checkboxSquareChecked, wrongAnswerIcon, arrowRight } = useIcons()

  const correctlyAnswered = computed(() => (itemId: string | undefined) => {
    if (!itemId) return false

    return props.correctItemIds.includes(itemId)
  })

  const answeredAllCorrectly = computed(() => props.leuckentextItems.length === props.correctItemIds.length)

  const evaluationStatus = computed(() => {
    return translateString('courses.leuckentext.evaluationStatus', {
      passed: props.correctItemIds.length,
      total: props.leuckentextItems.length,
      attempt: props.attempt,
    })
  })

return { __sfc: true,props, translateString, checkboxSquareChecked, wrongAnswerIcon, arrowRight, correctlyAnswered, answeredAllCorrectly, evaluationStatus, computed, LeuckentextQuestionItem, SVGRenderer, KetchUpButton, HTMLRenderer, useIcons, useI18n }
}

})